import React from "react";
import { useLanguage } from "../../../../contexts";
import "../RiskMatrixGuide/RiskMatrixGuide.scss";

export function Iso14091Guide() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  return (
    <div className="risk-matrix-guide">
      <h2>{t("risk_matrix_iso14091_guide_title")}</h2>
      <p>{t("risk_matrix_iso14091_guide_intro")}</p>
      <ol>
        <li>{t("risk_matrix_iso14091_guide_step1")}</li>
        <li>{t("risk_matrix_iso14091_guide_step2")}</li>
        <li>{t("risk_matrix_iso14091_guide_step3")}</li>
        <li>{t("risk_matrix_iso14091_guide_step4")}</li>
      </ol>

      <div className="risk-matrix-guide__note">{t("risk_matrix_iso14091_guide_auto_note")}</div>

      <h3>{t("risk_matrix_guide_criteria_title")}</h3>
      <table className="risk-matrix-guide__table">
        <thead>
          <tr>
            <th>{t("risk_matrix_guide_criteria_component")}</th>
            <th>{t("risk_matrix_guide_criteria_scale")}</th>
            <th>{t("risk_matrix_guide_criteria_use")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t("risk_matrix_iso14091_exposure")}</td>
            <td>1–5</td>
            <td>{t("risk_matrix_iso14091_guide_exposure_use")}</td>
          </tr>
          <tr>
            <td>{t("risk_matrix_iso14091_sensitivity")}</td>
            <td>1–5</td>
            <td>{t("risk_matrix_iso14091_guide_sensitivity_use")}</td>
          </tr>
          <tr>
            <td>{t("risk_matrix_iso14091_adaptive_capacity")}</td>
            <td>1–5</td>
            <td>{t("risk_matrix_iso14091_guide_adaptive_capacity_use")}</td>
          </tr>
          <tr>
            <td>{t("risk_matrix_iso14091_vulnerability")}</td>
            <td>1–5</td>
            <td>{t("risk_matrix_iso14091_guide_vulnerability_use")}</td>
          </tr>
          <tr>
            <td>{t("risk_matrix_level")}</td>
            <td>1–25</td>
            <td>{t("risk_matrix_iso14091_guide_level_use")}</td>
          </tr>
        </tbody>
      </table>

      <div className="risk-matrix-guide__ref">{t("risk_matrix_iso14091_guide_traceability")}</div>
    </div>
  );
}
